/* global Element */

/**
 * Append a context menu to an element. Use it with <i>new</i>.
 * @param {Element} node
 * Element where the menu should be append to.
 * Note: This function uses <i>appendChild</i> on this Element. So you can not
 * add a context menu to an input Element.
 * @param {Array} menuData
 * Arrray with objects of the following structure.<br>
 {<br>
 icon: [MaterialIcons name: String],<br>
 label: [Label text: String],<br>
 function: [Function to execute after click: function],<br>
 subMenu: [Array with the same structure as <i>menuData</i>: Array]<br> 
 }<br>
 * Sub menus have no deep limit. 
 * Functions on sub menus will not be executed on click.
 * @returns {Element} The menu Element. 
 * You should be able to add it on another place of DOM.
 * If you do, note that the parent should not have CSS position <i>static</i>.
 * @version 1.0.1
 * @author Konrad Klockgether
 */
function ContextMenu(node, menuData) {
  "use strict";

  //force new statement
  if (!(this instanceof ContextMenu)) return new ContextMenu(node, menuData);

  if (!(node instanceof Element)) throw new Error("node is not an Element");

  if (!Array.isArray(menuData)) throw new Error("menuData have to be an Array");

  //absolut position do not work with static objects
  if (window.getComputedStyle(node).position === "static")
    node.style.position = "relative";

  //build wrapper element
  var wrapper = document.createElement("div");
  wrapper.classList.add("context-menu");

  //build menu
  for (var i = 0, len = menuData.length; i < len; i++)
    wrapper.appendChild(createLi(menuData[i]));

  /**
   * Creates recursivly menu element items.
   * @param {Objects} liData
   * @returns {Element}
   */
  function createLi(liData) {
    var li = document.createElement("li");
    var liHTML = "";

    //icon
    if (!liData.icon) liData.icon = "o"; //will not be shown. only for space
    liHTML += '<i class="material-icons">' + liData.icon + "</i>";

    //label
    liHTML += "<label>" + liData.label + "</label>";

    //sub menu indicator icon. Only visible if li has a sub menu. Work with css class has-sub-menu of li Element
    liHTML += '<i class="material-icons sub-menu-indicator">chevron_right</i>';

    //insert html
    li.insertAdjacentHTML("beforeend", liHTML);

    //sub menu
    if (liData.subMenu) {
      //add class
      li.classList.add("has-sub-menu");

      //create node
      var subMenuWrapper = document.createElement("div");
      subMenuWrapper.classList.add("sub-menu");
      subMenuWrapper.classList.add("context-menu");

      //append children
      var subMenuItems = liData.subMenu;
      for (var i = 0, len = subMenuItems.length; i < len; i++)
        subMenuWrapper.appendChild(createLi(subMenuItems[i]));

      //append sub menu
      li.appendChild(subMenuWrapper);

      //touch event for open sub menu on mobile devices
      li.addEventListener("touchstart", function (e) {
        //prevent calling this by a sub sub menu to avoid hidding sub menu by click on sub sub menu
        //sub menu lis have only first level childs of visible elements.
        //This would work with e.target.parentNode.parentNode for second level. For third level you should implement an other check.
        if (this !== e.target && this !== e.target.parentNode) return;

        //toggle sub menu visibility
        if (this.classList.contains("is-active")) hideSubMenu(this);
        else showSubMenu(this);
      });
      //show sub menu on hover. Do not solve this with css :hover. iOS-Safari keeps hover after touchend
      //mouse over has somtimes issus with elements children. mouseenter is ok.
      li.addEventListener("mouseenter", function (e) {
        showSubMenu(this);
      });
      //show sub menu after leaving hover
      li.addEventListener("mouseleave", function (e) {
        //hide all sub menus of this
        hideSubMenu(this);
      });
    } else {
      //function
      //only add function if li has no sub menu
      if (typeof liData.function === "function") {
        //desktop
        li.addEventListener("click", getClickHandler(liData.function));
        //mobile
        li.addEventListener("touchend", getClickHandler(liData.function));
      }
    }

    return li;

    /**
     * Create a new function wich hide the context menu and executes the
     * event function.
     * @param {Function} event
     * @returns {Function}
     */
    function getClickHandler(event) {
      //create function for new scope
      return function () {
        //if you using fastclick.js sometimes you got a click and a touchend event.
        //So check if menu is visible to avoid double call.
        //If not visible, function was already executed.
        if (wrapper.classList.contains("is-active")) {
          hideMenu();
          event();
        }
      };
    }
  }

  //append ready menu to node
  node.appendChild(wrapper);

  //event listener to show menu by right click. Works only on desktop
  node.addEventListener("contextmenu", function (e) {
    //prevent showing browsers native context menu
    e.preventDefault();

    //check if you maybe do not have to show the menu
    if (!checkEventTarget(e)) return;

    //set menu positions to cursor
    wrapper.style.left = e.offsetX + "px";
    wrapper.style.top = e.offsetY + "px";

    //show menu
    wrapper.classList.add("is-active");

    //check menu position by beeing outside the view port
    checkWrapperRect(wrapper);

    //if user click on someting else, hide menu. Other event handlers will not be blocked.
    document.body.addEventListener("click", hideMenu);
  });

  //simulate long touch event
  var timeout;
  node.addEventListener("touchstart", function (e) {
    e.preventDefault();

    //check if you maybe do not have to show the menu
    if (!checkEventTarget(e)) return;

    //wait 300ms and show context menu
    timeout = setTimeout(function () {
      //set position to touch position
      var touch = e.touches[0];
      var targetRect = e.target.getBoundingClientRect();
      var offsetX = touch.clientX - targetRect.left;
      var offsetY = touch.clientY - targetRect.top;
      wrapper.style.left = offsetX + "px";
      wrapper.style.top = offsetY + "px";

      //show menu
      wrapper.classList.add("is-active");

      //check menu position by beeing outside the view port
      checkWrapperRect(wrapper);

      //wait some time for append click listener. fastclick.js could fire a click event for too short touch
      setTimeout(function () {
        //if user click on someting else, hide menu. Other event handlers will not be blocked.
        document.body.addEventListener("click", hideMenu);
      }, 400);
    }, 300);
  });
  //if touch is shorter than 300ms clear timeout to not to show context menu
  node.addEventListener("touchend", function (e) {
    clearTimeout(timeout);
  });

  return wrapper;

  /**
   * Inspect the show event and decide if menu should be shown or not.
   * @param {Event} e
   * @returns {Boolean}
   * <i>true</i> if menu should be show. Keep going.
   * <i>false</i> if menu should be keep hidden. Abort function.
   */
  function checkEventTarget(e) {
    //menu already visible?
    if (wrapper.classList.contains("is-active")) {
      //check if wrapper is in e.path
      var wrapperInPath = false;
      var nodeToCheck = e.target;
      while (nodeToCheck !== node) {
        if (nodeToCheck === wrapper) {
          wrapperInPath = true;
          break;
        }
        nodeToCheck = nodeToCheck.parentNode;
      }
      //if wrapper was found in event path, right click was on the menu
      //return false here to avoid hidding menu
      if (wrapperInPath) return false;

      //right click was not on menu. Hide menu to be able to open it on other position
      hideMenu();

      switch (e.type) {
        case "contextmenu":
          //return true to let show the menu on other position
          return true;
        default:
          //on touch events, do not show menu immediately. The timeouts can cause some wired behavior
          return false;
      }
    }
    return true;
  }

  /**
   * Makes sure the context menu main Element is compleetly in view port
   * @param {type} menuNode
   * @returns {undefined}
   */
  function checkWrapperRect(menuNode) {
    var nodeRect = menuNode.getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();

    //check X
    if (nodeRect.right > bodyRect.width)
      //on overlow on right side, stick on right view port edge
      menuNode.style.left =
        parseInt(menuNode.style.left) -
        (nodeRect.right - bodyRect.width) +
        1 +
        "px";

    //check Y
    if (nodeRect.bottom > bodyRect.height)
      //on overflow on bottom, stick on bottom edge of view port
      menuNode.style.top =
        parseInt(menuNode.style.top) -
        (nodeRect.bottom - bodyRect.height) +
        1 +
        "px";
  }

  /**
   * Makes sure the sub menu is compleetly in view port
   * @param {Element} menuNode
   * @returns {undefined}
   */
  function checkSubMenuRect(menuNode) {
    //reset sub menu position
    menuNode.style.right = null;
    menuNode.style.top = null;

    //get some positions and sizes
    var nodeRect = menuNode.getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();
    var parentRect = menuNode.parentNode.getBoundingClientRect();

    //check X
    //check if parent is sticked already on left side
    if (parentRect.left === 0) {
      //stick sub menu on right side

      //check if sub menu is right outer view port
      if (nodeRect.right > bodyRect.width)
        //stick on right view port edge
        menuNode.style.right =
          parseInt(window.getComputedStyle(menuNode).right) +
          (nodeRect.right - bodyRect.width) +
          "px";
    } else if (parentRect.right >= bodyRect.width - 1) {
      //check if parent is sticked on right side

      //put left from parent
      menuNode.style.right = nodeRect.width - 2 + "px";

      //check if sub menu is left outer view port
      nodeRect = menuNode.getBoundingClientRect();
      if (nodeRect.left < 0)
        //stick on left side of view port
        menuNode.style.right =
          parseInt(menuNode.style.right) + nodeRect.left + "px";
    } else {
      //sub menu is somewhere in the middle of view port

      //check if sub menu is right outer view port
      if (nodeRect.right > bodyRect.width) {
        //check if sub menu will fit left to parent
        if (parentRect.left >= nodeRect.width)
          //put left to parent
          menuNode.style.right = nodeRect.width - 2 + "px";
        //-2 cause of the border
        //stick on right view port edge
        else
          menuNode.style.right =
            parseInt(window.getComputedStyle(menuNode).right) +
            (nodeRect.right - bodyRect.width) +
            "px";
      }
    }

    //check Y
    //check if sub menu bottom is outer the view port
    if (nodeRect.bottom > bodyRect.height)
      //stick on bottom view port edge
      menuNode.style.top =
        parseInt(window.getComputedStyle(menuNode).top) -
        (nodeRect.bottom - bodyRect.height) +
        "px";
  }

  /**
   * Hide context menu and unbind event listener of document
   * @param {Event} e
   * @returns {undefined}
   */
  function hideMenu(e) {
    if (e) {
      //check if user clicked on a visible context menu. If yes, do not hide.
      var nodeToCheck = e.target;
      while (nodeToCheck !== document.body && nodeToCheck !== node) {
        var classList = nodeToCheck.classList;
        if (
          classList &&
          classList.contains("context-menu") &&
          classList.contains("is-active")
        )
          return;
        nodeToCheck = nodeToCheck.parentNode;
      }
    }

    //always self remove this listener from body to keep it clean
    document.body.removeEventListener("click", hideMenu);

    //hide menu with all sub menus
    hideSubMenu(wrapper);

    //reset position for fresh calculations
    wrapper.style.top = null;
    wrapper.style.left = null;
  }

  /**
   * Show sub menu and position it
   * @param {type} li
   * @returns {undefined}
   */
  function showSubMenu(li) {
    //hide other sub menus
    var subMenus = li.parentNode.children;
    for (var i = 0, len = subMenus.length; i < len; i++) {
      var subMenuToCheck = subMenus[i];
      if (subMenuToCheck !== li) subMenuToCheck.classList.remove("is-active");
    }

    //show sub menu
    li.classList.add("is-active");
    //check for beeing outer view port
    checkSubMenuRect(li.querySelector(".sub-menu"));
  }

  /**
   * Hide self and all sub menus of self
   * @param {Element} li
   * @returns {undefined}
   */
  function hideSubMenu(li) {
    //hide menu
    li.classList.remove("is-active");

    //hide all sub menus
    var thisSubMenus = li.querySelectorAll("li.is-active");
    for (var i = 0, len = thisSubMenus.length; i < len; i++)
      thisSubMenus[i].classList.remove("is-active");
  }
}
